@if (alertMessage) {
<ngb-alert
  #selfClosingAlert
  [type]="_content.type"
  class="my-3 my-lg-4"
  (closed)="alertMessage = ''"
>
  {{ alertMessage }}
</ngb-alert>
}